module.exports = __webpack_public_path__ + "img/icon-star-opaque.1abad5c5.svg";